import { render, staticRenderFns } from "./EmpresaExport.vue?vue&type=template&id=18df6bb9"
import script from "./EmpresaExport.vue?vue&type=script&lang=js"
export * from "./EmpresaExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports